var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVisionOn = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.767 6.696C21.58 8.098 22.95 9.904 24 12.006l-.383.7c-3.934 7.44-12.95 9.577-19.384 4.598C2.42 15.902 1.05 14.096 0 11.994l.383-.7c3.933-7.44 12.95-9.577 19.384-4.598M5.643 8.698c-1 .761-1.834 1.695-2.577 2.737-.301.423-.276.736.014 1.145 2.237 3.167 5.193 4.823 8.89 4.922 3.728-.093 6.672-1.736 8.918-4.867.343-.477.326-.825-.01-1.286-.722-.986-1.52-1.88-2.47-2.614-.151-.116-.313-.353-.498-.248-.223.128-.036.376-.005.56.737 4.33-2.603 8.113-6.69 7.572-3.418-.453-5.756-3.94-5.11-7.618.03-.171.189-.393-.007-.514-.173-.106-.319.107-.455.211m4.112-1.556c-1.194.018-2.134 1.043-2.133 2.325 0 1.29.952 2.324 2.132 2.318 1.22-.007 2.174-1.041 2.165-2.347-.009-1.266-.997-2.315-2.164-2.296"
  })));
};
export default SvgVisionOn;